import m from "../../geodata/es2015/sudanLow";
window.am4geodata_sudanLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/sudanLow.js
// module id = null
// module chunks = 